"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const expect = require("assert");
const sinon_1 = require("sinon");
const container_1 = require("./container");
const globals_1 = require("./globals");
const types_1 = require("./types");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const index_1 = require("./index");
describe('index', () => {
    beforeEach(() => {
        container_1.container.snapshot();
        delete require.cache[require.resolve('./index')];
    });
    afterEach(() => {
        container_1.container.restore();
    });
    it('exposes the api via import', () => {
        expect.equal(index_1.default, container_1.container.get(types_1.TYPE_API));
    });
    it('exposes the api via require', () => {
        const index = require('./index');
        expect.equal(index, container_1.container.get(types_1.TYPE_API));
    });
    it('all exposed methods are bound to correctly (this works)', () => {
        const publicMethods = {
            setupInMemoryTranspile: sinon_1.spy(),
            getGlobalConfiguration: sinon_1.spy(),
            setGlobalConfiguration: sinon_1.spy(),
            getTool: sinon_1.spy(),
            initializeTask: sinon_1.spy(),
            initializeTasks: sinon_1.spy(),
            initializePreset: sinon_1.spy(),
            initializePresets: sinon_1.spy(),
            initialize: sinon_1.spy()
        };
        const apiMock = Object.assign({}, publicMethods);
        container_1.container.rebind(types_1.TYPE_API).toConstantValue(apiMock);
        const index = require('./index');
        Object.keys(publicMethods).forEach(methodName => {
            const method = index[methodName];
            method();
            expect.equal(publicMethods[methodName].calledOn(apiMock), true);
        });
    });
    it('sets globals automatically', () => {
        const configServiceMock = {
            mergeParameters: sinon_1.spy(),
            setGlobalConfiguration: sinon_1.spy(),
            getGlobalConfiguration: sinon_1.spy()
        };
        container_1.container.rebind(urbanjs_tools_core_1.TYPE_SERVICE_CONFIG).toConstantValue(configServiceMock);
        require('./index');
        expect.equal(configServiceMock.setGlobalConfiguration.calledWith(globals_1.globals), true);
    });
});
